<template>
  <mw-dialog ref="dialog" :title="$lang('附件管理')" :appendToBody="false"  size='large_mini'>
    <mw-ntko-attachment @dataLoaded='tableDataLoaded' :defButtons="buttons"  :propObject="propObject"/>
  </mw-dialog>
</template>
<script>
export default {
    // props: {
    //   params: {
    //    type: Object
    //   }
    // },
    data() {
      let me = this;
      me.form = me.$attrs.params.form;
      let formObj=me.$attrs.params.form;
    return {
      propObject:{
        params:{
          form : formObj,
          editable:this.$attrs.params.editable,
          editMode:this.$attrs.params.editable,
          businessId: this.$attrs.params.businessId,
          formId: this.$attrs.params.formId,
          tempBusinessId: this.$attrs.params.tempBusinessId,
          isShowInFormPanel: "0",
          efileType: "JOA_FJ"
        }
      },
      buttons: [
        { id: "add", name: $lang("添加"), class: "fa fa-plus-square fa-fw" },
        { id: "scanner", name: $lang("扫描"), class: "fa fa-plus-circle fa-fw" },
        { id: "deleteAttach", name: $lang("删除"), class: "fa fa-trash-o fa-fw" },
        { id: "down", name: $lang("下载"), class: "fa fa-download fa-fw" },
        { id: "downall", name: $lang("全部下载"), class: "fa fa-download fa-fw" },
        { id: "print", name: $lang("打印"), class: "fa fa-print fa-fw" },
        { id: "listview", name: $lang("列表"), class: "fa fa-list-alt fa-fw" },
        { id: "iconview", name: $lang("图标"), class: "fa fa-file-image-o fa-fw" },
        { id: "doMoveSelectFileUp", name: $lang("上移"), class: "fa fa-arrow-up fa-fw" },
        { id: "doMoveSelectFileDown", name: $lang("下移"), class: "fa fa-arrow-down fa-fw" },
        { id: "rename", name: $lang("重命名"), class: "fa fa-file-image-o fa-fw" }
      ]
    };
  },
  mounted() {
    setTimeout(()=>{
      this.show();
    },200)
  },
  methods: {
    tableDataLoaded(data){
      this.$attrs.params.func(data);
    },
    show(){
        this.mwRef('dialog').show();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/ntko/ntko-attachment.vue